import { fetch } from '@/utils/http'

export default {
  catchTraffic: params => fetch('post', '/cbaas-service/v1/performance/catchTraffic', params, true), //自动测试-实时捕获流量
  analyse: params => fetch('post', '/cbaas-service/v1/performance/analyse', params), //自动测试-分析
  contractDetact: params => fetch('post', '/cbaas-service/v1/performance/contractDetact', params), //手动测试-检测是否部署存证合约
  contractInstall: params => fetch('post', '/cbaas-service/v1/performance/contractInstall', params), //手动测试-部署存证合约
  pressureTest: params => fetch('post', '/cbaas-service/v1/performance/pressureTest', params) //手动测试
}
